import { getClusters } from '../services';
export const fetchClusters = () => getClusters().then(response => formatResponse(response?.data));
const formatResponse = (response) => response?.data.map((campaign, index) => ({
    label: campaign,
    value: index,
}));
